import { SkeletonSectionType } from '../enums/skeleton-section-type.enum';

import styles from './SkeletonSection.module.scss';

export const SkeletonSection = ({ type }: { type: SkeletonSectionType }) => {
  const classNames = [styles['skeleton'], styles[`skeleton--${type}`]];

  if (type === SkeletonSectionType.nftCard) {
    return (
      <div className={[...classNames, styles['skeleton-nft']].join(' ')}>
        <div className={styles['skeleton-nft__image']}></div>
        <div className={styles['skeleton-nft__details']}>
          <div className={styles['skeleton-nft__details-row']}></div>
          <div className={styles['skeleton-nft__details-row']}></div>
        </div>
        <div className={styles['skeleton-nft__footer']}></div>
      </div>
    );
  }

  if (type === SkeletonSectionType.filter) {
    return (
      <div className={[...classNames, styles['skeleton-filter']].join(' ')}>
        <div className={styles['skeleton-filter__title']}></div>
        <div className={styles['skeleton-filter__details']}>
          <div className={styles['skeleton-filter__details-row']}></div>
          <div className={styles['skeleton-filter__details-row']}></div>
        </div>
      </div>
    );
  }

  if (type === SkeletonSectionType.tableRow) {
    return (
      <div className={[...classNames, styles['skeleton-table-row']].join(' ')}>
        <div className={styles['skeleton-table-row__section-badge']}></div>
        <div className={styles['skeleton-table-row__section-user']}></div>
        <div className={styles['skeleton-table-row__section-text']}></div>
      </div>
    );
  }

  if (type === SkeletonSectionType.tableHeader) {
    return (
      <div className={[...classNames, styles['skeleton-table-header']].join(' ')}>
        <div className={styles['skeleton-table-header__section-left']}></div>
        <div className={styles['skeleton-table-header__section-right']}></div>
      </div>
    );
  }

  return <div className={classNames.join(' ')}></div>;
};
